const en = {
  "the-need-page": {
    "hero-section": {
      heading: "Education Rooted in Faith: A Necessity for Today",
      description:
        "In a rapidly changing world, the need for holistic education rooted in Islamic values has never been greater. At QiblaSchools, we bridge the gap between tradition and modernity, empowering young minds with the knowledge, faith, and skills to thrive in life while staying grounded in their deen. Join us in cultivating a generation that leads with integrity, compassion, and a sense of purpose.",
    },
    "history-section": {
      heading: "Reviving Progress in Ummah",
      description1:
        "For the past 400 years, Islamic societies have experienced a period of decline, leading to fractured communities and stunted progress. Despite representing 25% of the world's population, OIC (Organization of Islamic Cooperation) countries often lag behind in crucial global rankings. These nations frequently score lower on indices measuring happiness, transparency, and per capita income. High levels of corruption and limited economic opportunities impede progress, contributing to a lower quality of life for many citizens",
      description2:
        "This stark reality underscores the urgent need for systemic change and effective leadership tounlock the potential of these countries and improve the well-being of their people. At Qibla, we are committed to addressing these challenges by fostering innovation, ethical governance, and sustainable development rooted in Islamic values. Education is the cornerstone of this transformation. QiblaSchools is at the forefront of this mission, delivering high-quality, values-driven education that equips students with the skills, knowledge, and character needed to thrive in a rapidly changing world. By integrating modern learning methodologies with Islamic principles, QiblaSchools empowers the next generation to become ethical leaders, critical thinkers, and innovators",
    },
    "innovation-gap-section": {
      heading: "The Innovation Gap: A Call for Change",
      description:
        "Patent filings by OIC countries constitute only 1.5% of the global total,despite these nations representing a significant portion of the world’s population. This disparity highlights a substantial gap in innovation and intellectual property contributions. Our progress is hindered by several critical issues",
      reasons: [
        {
          heading: "Ideological Confusion",
          description: "A lack of clarity and coherence in our collective vision and values hinders unified efforts towards innovation and development",
          imgKey: "confusion.png",
        },
        {
          heading: "Intellectual Dishonesty",
          description: "Dishonest practices in academic and professional fields stifle genuine progress and undermine trust in our institutions",
          imgKey: "dishonesty.jpg",
        },
        {
          heading: "Oppression",
          description: "Various forms of oppression limit freedom, creativity, and the ability to contribute to global advancements",
          imgKey: "oppression.jpg",
        },
        {
          heading: "Tribal Mindset",
          description: "Prioritizing narrow, local interests over broader, communal progress leads to fragmented efforts and missed opportunities",
          imgKey: "tribal.jpg",
        },
        {
          heading: "Shortage of Effective Leaders",
          description: "There is a critical need for visionary and effective leaders who can inspire and drive meaningful change within our societies",
          imgKey: "leader.jpg",
        },
      ],
    },
    "vision-section": {
      heading: "Our Vision for Change",
      description:
        "Through the Qibla platform, we aspire to transform the current landscape, overcoming the obstacles that hinder our progress and unlocking the vast potential within our communities. Education is the key to this transformation. Together, we can make significant strides towards innovation, development, and global contribution",
      "key-areas": [
        {
          heading: "Leadership",
          description:
            "Essential for guiding the community with justice and wisdom, ensuring collective adherence to ethical principles and the teachings of how to live",
        },
        {
          heading: "Personal-Development",
          description:
            "Aligns with the pursuit of bettering oneself to fulfill one's duties to Allah (SWT) and humanity, promoting personal growth and spiritual well-being",
        },
        {
          heading: "Islamic Pedagogy",
          description:
            "Fosters a holistic education that integrates spiritual, moral, and intellectual development, ensuring individuals are guided by ethical principles and a deep understanding of their faith",
        },
      ],
      footer:
        "By addressing these areas, we aim to create a platform that not only honors our rich Islamic heritage but also builds a future grounded in the values and teachings of Islam. Join us at Qibla as we work towards a brighter future for Islamic societies, driven by education, innovation, and ethical leadership. Together, we can shape a world where our communities thrive and contribute positively to global advancements",
    },
  },

  "approach-page": {
    "hero-section": {
      heading: "A Timeless Approach to Education: Bridging Faith and Modernity",
      description:
        "At Qibla, we aim to seamlessly weave the Islamic value system with the contemporary world, drawing inspiration from our rich past while looking towards a brighter future. Islamic values and history are deeply enriched with innovations and exemplary governance. For over 1400 years, Islamic civilization has contributed significantly to various fields, fostering advancements that have shaped the world. However, it is only in the past 400 years that Islamic societies have experienced a period of decline.",
    },
    "history-section": {
      heading: "Guided by Wisdom, Rooted in History",
      description:
        "Our platform is dedicated to rekindling this illustrious heritage by drawing inspiration from the countless role models within Islamic history. Among them, the greatest role model is the Prophet Muhammad (peace be upon him), who exemplified unparalleled leadership and teaching.",
      hadithMonologue: "His profound impact is reinforced by the Hadith from Ibn Majah's collection, where the Prophet (peace be upon him) said, ",
      hadith: "Verily, I was sent as a teacher",
    },
    "core-components-section": {
      heading: "Core Components",
      description:
        "The life and principles of the Prophet Muhammad (peace be upon him) serve as a timeless guide for leadership, personal development, pedagogy, and effective governance. By embracing these values, we strive to a Platform:",
      components: [
        {
          heading: "Leadership",
          description:
            "Leadership is at the core of Qibla’s mission, drawing inspiration from the Prophet Muhammad’s ﷺ exemplary leadership. The platform fosters leadership qualities among educators, students, and community members by instilling values such as integrity, wisdom, and responsibility.",
          imgKey: "leadership.jpg",
        },
        {
          heading: "Islamic Pedagogy",
          description:
            "Qibla Platform is deeply rooted in Islamic pedagogy, incorporating traditional Islamic educational principles with modern teaching methodologies. This approach ensures a balanced and holistic learning experience that nurtures both the intellect and character of students.",
          imgKey: "islamic-pedagogy.jpg",
        },
        {
          heading: "Global and Local Reach",
          description:
            "The platform addresses a global audience while maintaining a strong local presence through Qibla School, an on-ground model institution. This integration of digital and physical education ensures that students worldwide benefit from an authentic and immersive learning experience.",
          imgKey: "global-reach.jpg",
        },
        {
          heading: "Curated Educational Resources",
          description:
            "Qibla Platform provides high-quality, carefully curated educational content focused on Islamic pedagogy. This ensures students and educators have access to the best resources for continuous learning and the effective implementation of Islamic educational principles.",
          imgKey: "educational-recources.jpg",
        },
        {
          heading: "Professional Development",
          description:
            "Recognizing the critical role of educators, Qibla places a strong emphasis on continuous professional development. Specialized training in Islamic pedagogy equips teachers with the latest instructional strategies, enhancing their teaching effectiveness and career growth.",
          imgKey: "professional-development.jpg",
        },
        {
          heading: "Innovative Educational Model",
          description:
            "Qibla leverages advanced technologies, including Artificial General Intelligence (AGI), to offer personalized learning experiences. These innovations complement traditional curricula and provide real-world apprenticeship opportunities, preparing students for future success.",
          imgKey: "innovative-education.jpg",
        },
        {
          heading: "Student-Centered Learning",
          description:
            "The platform adopts a student-centric approach, nurturing both intellectual and spiritual development. By fostering critical thinking, creativity, and ethical values, Qibla prepares students to become future leaders who positively contribute to society.",
          imgKey: "student-learning.jpg",
        },
        {
          heading: "Engagement and Governance",
          description:
            "Qibla ensures effective management and strategic oversight through a dedicated Governing Council and Steering Committee. Transparent communication and continuous stakeholder engagement align the platform with community needs and expectations.",
          imgKey: "governance.jpg",
        },
      ],
    },
    "free-courses-section": {
      heading: "Free Courses for Lifelong Islamic Learning",
      description:
        "we aspire to create a platform that not only honors our past but also builds a future grounded in the rich traditions and teachings of Islam. By learning from our history and guided by the exemplary life of the Prophet Muhammad (peace be upon him), we can pave the way for a renaissance in Islamic thought and practice. The LMS will contain free to use courses:",
      courses: [
        // {
        //   heading: "Angel Academy curriculum and tools",
        // },
        {
          heading: "Leadership course for students",
          subHeading: "(1 hour per week)",
        },
        {
          heading: "Islamic Pedagogy Course",
          subHeading: "(Sub courses e.g. Tarbiya)",
        },
        {
          heading: "PD Leadership rooted in Islamic values",
        },
        {
          heading: "Islamic Psychology - Personal Development",
        },
      ],
    },
  },

  "courses-page": {
    "hero-section": {
      heading: "Free Education for All: Empowering Minds, Enriching Communities",
      description:
        "At Qibla, we firmly believe that education is the cornerstone of progress and development. It is the key to unlocking potential, fostering innovation, and building strong, resilient communities. As part of our vision to empower individuals and communities, we are creating an online platform that offers a wide range of free courses accessible to all.",
    },
    "offering-section": {
      heading: "What We Offer?",
      description:
        "Our platform is designed to provide valuable knowledge and skills, rooted in Islamic values, to inspire personal growth and community leadership. We understand the transformative power of education and are committed to making high-quality learning opportunities available to everyone, regardless of their background or circumstances.",
      "key-areas": [
        {
          heading: "Free Online Courses",
          description:
            "Our platform will feature a diverse array of courses covering various subjects. Each course is meticulously designed to ensure it aligns with Islamic principles while providing practical and relevant knowledge.",
        },
        {
          heading: "Curated Content",
          description:
            "In addition to our own courses, we will curate valuable content from across the web. This will provide you with a rich repository of resources to browse and learn from, enhancing your educational journey and broadening your horizons.",
        },
      ],
    },
  },

  "collaboration-page": {
    "hero-section": {
      heading: "Collaborate, Share, and Inspire: Growing a Learning Community",
      description:
        "At Qibla Platform, we believe in the power of shared knowledge. Our commitment to education and personal development drives us to provide open access to high-quality resources, lesson plans, and curated content—all rooted in Islamic values. Join us in building a collaborative community where educators, students, and lifelong learners can thrive.",
    },
    "collaboration-section": {
      heading: "Our Commitment to Open Learning and Collaboration",
      description:
        "At Qibla Platform, we are dedicated to sharing our work with anyone who is interested. Our mission is to provide access to valuable resources that can inspire and support educational and personal development initiatives. Our commitment includes:",
      "key-areas": [
        {
          heading: "Our Online Platform Based on Moodle LMS",
          description:
            "We utilize the Moodle Learning Management System to create an interactive and user-friendly online platform. This allows educators, students, and lifelong learners to access a wide range of courses and materials designed to foster growth and development rooted in Islamic values.",
        },
        {
          heading: "Curated Content and Practices",
          description:
            "We offer carefully curated content that includes best practices, innovative teaching methods, and valuable insights from Islamic history and contemporary education. Our content is designed to inspire and equip educators with the tools they need to create meaningful learning experiences.",
        },
        {
          heading: "Lesson Plans and Activity Sheets",
          description:
            "Our platform provides comprehensive lesson plans and activity sheets that are ready to use in various educational settings. These resources are created to align with Islamic principles and values, ensuring that educators have access to high-quality materials that promote holistic development.",
        },
      ],
      footer:
        "Through these offerings, we aim to create a collaborative and supportive community where knowledge is freely shared, and everyone has the opportunity to benefit from our collective efforts. Join us at Qibla Platform as we work together to inspire and educate the next generation of leaders and learners.",
    },
  },

  "services-page": {
    "hero-section": {
      heading: "Empowering Islamic Schools with Digital Excellence",
      description:
        "At Qibla, we leverage our extensive experience and unwavering commitment to Islamic values to offer unparalleled services to Islamic schools worldwide. Based in Pakistan, we are uniquely positioned to provide competitive and cost-effective solutions without compromising on quality. Our mission is to support Islamic educational institutions in their journey toward digital excellence, recognizing that education and Islamic values are the keys to nurturing future leaders and innovators.",
    },
    "dedication-section": {
      heading: "Dedicated to Islamic Education",
      description:
        "We are passionate about empowering Islamic schools with innovative, cost-effective digital solutions. By integrating Islamic values with modern technology, we strive to enhance the educational experience, ensuring quality, accessibility, and excellence in every service we provide.",
      "key-areas": [
        {
          heading: "Our Vision and Mission",
          description:
            "We understand the unique challenges faced by Islamic schools and are dedicated to providing tailored solutions that meet their specific needs. Our comprehensive approach ensures that every aspect of the educational experience is enhanced through innovative digital solutions. We believe that by integrating Islamic values with modern technology, we can create a transformative impact on education.",
        },
        {
          heading: "Our Commitment to Excellence",
          description:
            "At Qibla, we are committed to delivering the best possible service at the lowest possible cost. We understand the financial constraints many Islamic schools face and strive to provide solutions that are both affordable and effective. Our team is dedicated to excellence, ensuring that every service we offer meets the highest standards of quality and integrity.",
        },
      ],
    },
  },

  "donations-page": {
    "hero-section": {
      heading: "Empower the Future: Support Islamic Education",
      description:
        "At Qibla, your support transcends a mere donation; it is an investment in the future of our community and the generations to come. Together, we have the opportunity to nurture leaders who will make a positive and lasting impact on the world. Your contribution helps us create an environment where Islamic values and modern education converge, fostering innovation, leadership, and personal growth",
    },
    "how-support-makes-difference-section": {
      heading: "How Your Support Makes a Difference",
      description:
        "By supporting Qibla, you are playing a crucial role in shaping a brighter future. Your contributions will help us build a foundation of excellence, rooted in Islamic values and geared towards holistic development. Join us in making a lasting impact—together, we can create a legacy of knowledge, leadership, and positive change.",
      "key-areas": [
        {
          heading: "General Purpose Hall",
          description: "This space will serve as a hub for community activities, events, and large gatherings, fostering a sense of unity and collaboration",
        },
        {
          heading: "STEAM Lab",
          description:
            "A state-of-the-art lab dedicated to Science, Technology, Engineering, Arts, and Mathematics, empowering students with hands-on learning experiences and innovative thinking.",
        },
        {
          heading: "Classrooms",
          description: "Each classroom will be a beacon of learning, equipped with modern facilities to provide an enriching educational environment.",
        },
        {
          heading: "Offices and Other Facilities",
          description: "Essential administrative and support spaces that ensure the smooth operation of our institution.",
        },
        {
          heading: "Online Platform Development:",
          description: "Creating a digital platform that connects students, educators, and resources, facilitating remote learning and global collaboration.",
        },
      ],
    },
  },

  "updates-page": {
    "hero-section": {
      heading: "Stay Updated with Qibla Platform's Progress",
      description:
        "At Qibla, we believe that education is the cornerstone of progress and development. Our commitment to fostering innovation, leadership, and personal growth through education is unwavering, and we are excited to share our journey with you",
    },
    "journey-section": {
      heading: "Our Journey of Growth and Innovation",
      description:
        "We are committed to building a future where Islamic values and modern education come together to inspire and empower learners. Through the construction of our on-ground school and the development of our online platform, we aim to create transformative learning experiences. Stay updated on our progress, milestones, and innovations as we work towards shaping the next generation of leaders.",
      "key-areas": [
        {
          heading: "Our Vision",
          description:
            "On this page, we aim to provide regular updates on our progress across various domains. Our primary focus is on the construction phase of our on-ground school and the development of our online platform. These updates will offer insights into the milestones we achieve, the challenges we overcome, and the transformative impact we aspire to create.",
        },
        {
          heading: "Construction Phase of the On-Ground School",
          description:
            "The establishment of our on-ground school is a significant step towards realizing our vision. This school will serve as a beacon of excellence, integrating Islamic values with modern education to nurture future leaders. We will share detailed updates on the construction process, from the initial groundbreaking to the completion of state-of-the-art facilities. Stay tuned for exciting news about our progress, including photos, videos, and stories from the construction site.",
        },
        {
          heading: "Development of the Online Platform",
          description:
            "Our online platform is designed to provide a comprehensive digital learning environment that aligns with our educational philosophy. We will keep you informed about the development stages, new features, and the launch of various courses. This platform will offer a range of educational resources, including the Angel Academy curriculum, leadership courses, Islamic pedagogy, and more. Our goal is to create an interactive and user-friendly space where educators, students, and lifelong learners can thrive",
        },
      ],
    },
  },

  "contact-page": {
    "hero-section": {
      heading: "Get in Touch: Let's Connect and Grow Together",
      description:
        "Have questions or want to collaborate? We’d love to hear from you! Reach out to us for inquiries, support, or partnership opportunities. Together, we can make a meaningful impact on education and the future of our community.",
    },
  },
};

export default en;
